import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { Button, Modal } from "react-bootstrap";

//ACTIONS
import * as UserActions from "../../../../../../../store/actions/user";

//STYLES
import * as ChangeOfSeniorRequestStyles from "../styles/changeOfSeniorRequest";

function ChangeOfSeniorRequest(props) {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const organisation = useSelector((state) => state.organisation);
    const user = useSelector((state) => state.user);

    const [settings, setSettings] = useState({
        organisation: {}
    });

    const [modal, setModal] = useState({
        open: false,
        heading: "",
        message: ""
    });

    function handleModalClose() {
        navigate("/", { replace: true });

        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        onLoad();
    }, []);

    function onLoad() {
        const data = { orgID: params.orgID };
        Axios.post("/security/getSARData", data)
            .then((res) => {
                console.log(res.data.org);
                setSettings({ organisation: res.data.org });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function handleAccept() {
        const data = { orgID: params.orgID, invate: "Accept", newUserID: user.uuid };
        Axios.post("/security/SAInvate", data)
            .then((res) => {
                console.log(res.data);
                if (res.data.message == "Senior Admin Updated") {
                    dispatch(UserActions.userUpdateRole(res.data.role));
                    dispatch(UserActions.userUpdateSARequest(""));

                    setModal({ heading: "Request Accepted", open: true });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function handleDecline() {
        const data = { orgID: params.orgID, invate: "Decline", newUserID: user.uuid };
        Axios.post("/security/SAInvate", data)
            .then((res) => {
                if (res.data.message == "Senior Admin Request Declined") {
                    dispatch(UserActions.userUpdateSARequest(""));

                    navigate("/", { replace: true });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <div style={ChangeOfSeniorRequestStyles.body}>
            <div style={ChangeOfSeniorRequestStyles.innerContainer}>
                <h1>Change of Senior Admin Request</h1>
                <br />
                <p>You are viewing this screen because {settings.organisation.POC_Name} has requested a change of Senior Admin role to you. </p>
                <p>This means that you will be responible for the admin side of your organisation.</p>
                <p>If you require help, please speak to {settings.organisation.POC_Name} or contact High-View Studios</p>
                <p>Do you want to Accept or Decline this invitation?</p>
                <br />
                <div style={ChangeOfSeniorRequestStyles.buttons}>
                    <Button variant="success" onClick={handleAccept}>
                        Accept
                    </Button>
                    <Button variant="success" onClick={handleDecline}>
                        Decline
                    </Button>
                </div>
            </div>
            <Modal show={modal.open} onHide={handleModalClose}>
                <Modal.Header>
                    <Modal.Title>{modal.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>You are now the Senior Admin of this organisation.</p>
                    <p>To get to the Admin side, go on the organisation page drop-down at the top-right of the screen</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ChangeOfSeniorRequest;
